$(document).ready(function () {

  $('.cookie-banner-content p').html(`We use cookies to offer you a better browsing experience, analyze site traffic, personalize content and serve targeted advertisements. To learn more or change your cookie preferences, choose <em>Manage Cookie Preferences</em>. For further information on the use of cookies and information we collect, visit our <a href="https://www.asmglobal.com/p/other/privacy-policy" target="_blank">Privacy Policy</a>.`);

  // General Message
  $('.generalmessage').prependTo('header');

  // Searchbox placeholder
  const searchBoxInput = $('.header .searchBox input');
  searchBoxInput.attr('placeholder', 'Search Website');
  searchBoxInput.val('');


  // move social icons in footer
  $('.socialNetworks').appendTo('.footer-social');

});
